import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";

import {
    sendRequestMixedClassLogin,
    setCurrentBrowserType,
    setCurrentPageType
} from "../lib/RabbitmqClient";

import {
    joinLive,
    requestJoinMixedClassLive,
    toggleIsNeedGoToHome
} from "../modules/live";

import {
    setLoginMessage,
    saveTempMixedUserInfo,
    requestMixedClassLoginList,
    reqeustMixedClassLogout
} from "../modules/user";

import MixedClassLoginWindow from "../components/live/mixedClass/MixedClassLoginWindow";
import { isEmptyObj } from "../lib/func/ExportFunction";

class MixedLoginContainer extends Component {

    // 20260819 Mixed Class 로그인에서 선택한 크롬북 화면 공유 방향 보정값을 라이브 이동 시까지 유지한다.
    rotateCapture = false;

    getLivePath = (liveSeq) => this.rotateCapture ? `/live/${liveSeq}?rotateCapture=-90` : `/live/${liveSeq}`;

    // 20260819 크롬북에서 기억한 화면 공유 방향 보정 설정을 Mixed Class 로그인에 복원한다.
    initializeRotateCapture = () => {
        try {
            const userAgent = navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
            this.rotateCapture = userAgent.indexOf("cros") > -1 && window.localStorage.getItem("qrLoginRotateCapture") === "-90";
        } catch (err) {
            this.rotateCapture = false;
        }
    }

    state = {
        loginInfo       : {}
    }

    componentDidMount() {
        this.initializeRotateCapture();

        console.log("MixedLoginContainer DidMount - set current browserType");
        setCurrentBrowserType(this.props.browserType);
        console.log("MixedLoginContainer DidMount - set current pageTyle");
        setCurrentPageType(this.props.currentPageType);

        if (this.props.isLoginYn === "Y") {
            if (typeof this.props.userSeq === "number" && this.props.userSeq > -1) {
                console.log("MixedLoginContainer(1) - have to request logOut ... userSeq => " + this.props.userSeq);
                this.props.reqeustMixedClassLogout({
                    userSeq: this.props.userSeq,
                    mode: "web"
                });
            } else {
                console.log("MixedLoginContainer(1) - can not request logOut ... userSeq => " + this.props.userSeq);
            }
        } else {
            if (!this.props.isRbmqServerConnected) {
                const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
                if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                    if (mixedClassSeq > 0) {
                        console.log("MixedLoginContainer(2-1) - have to request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                        this.props.requestMixedClassLoginList({
                            mixedClassSeq: parseInt(mixedClassSeq),
                            userKind: this.props.userKind
                        });
                    } else {
                        console.log("MixedLoginContainer(2-2) - can not request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                    }
                } else {
                    console.log("MixedLoginContainer(2) - can not request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && this.props.isRbmqServerConnected) {
            console.log("MixedLoginContainer(3) - temp key connected.");
            const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
            if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                console.log("MixedLoginContainer(3) - have to request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
            } else {
                console.log("MixedLoginContainer(3) - can not request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
            }
        } else {
            // 클래스 입장 후 뒤로 가기했을 경우 로그아웃이 실행되기 때문에 didmount때 받아온 데이터가 모두 사라지므로 로그인 가능 목록 재호출.. by hjkim 20230417
            if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && !this.props.isRbmqServerConnected) {
                const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
                if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                    if (mixedClassSeq > 0) {
                        console.log("MixedLoginContainer(4-1) - have to request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                        this.props.requestMixedClassLoginList({
                            mixedClassSeq: parseInt(mixedClassSeq),
                            userKind: this.props.userKind
                        });
                    } else {
                        console.log("MixedLoginContainer(4-2) - can not request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                    }
                } else {
                    console.log("MixedLoginContainer(4) - can not request requestMixedClassLoginList ... mixedClassSeq => " + mixedClassSeq);
                }
            }
        }

        /* if (prevProps.isLoginYn !== this.props.isLoginYn && this.props.isLoginYn === "Y") {
            this.handleSelectedFunc({ selectedFunc: "JOIN" });
        } */

        console.log(`MixedLoginContainer(5) componentDidUpdate - liveSeq[${this.props.performLiveSeq}], isRbmqServerConnected[${this.props.isRbmqServerConnected}]`);
        if (this.props.isRbmqServerConnected && this.props.performLiveSeq > -1) {
            if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive) {
                console.log("MixedLoginContainer(5) - go to live page ... liveSeq => " + this.props.performLiveSeq);
                console.log("MixedLoginContainer(5) - isGotoWebLive is true!!!!! go to live page!!!");
                this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
            }
        }

        /* if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive) {
            console.log("MixedLoginContainer(5) - go to live page ... liveSeq => " + this.props.performLiveSeq);
            if (this.props.isRbmqServerConnected && this.props.performLiveSeq > -1) {
                console.log("MixedLoginContainer(5) - go to live page ... liveSeq => " + this.props.performLiveSeq);
                this.props.routeProps.history.push(`/live/${this.props.performLiveSeq}`);
            }
        } */
    }

    handleSelectedFunc = ({ selectedFunc, live_info, loginInfo }) => {
        switch (selectedFunc) {
            case "GET_LOGIN_INFO":
                break;

            case "JOIN":
                /* this.props.handleSelectedFunc({
                    selectedFunc: "JOIN",
                    liveSeq: this.props.mixedClassInfo.liveSeq,
                    liveName: this.props.mixedClassInfo.liveName,
                    mixedClassSeq: this.props.mixedClassInfo.mixedClassSeq
                }); */

                if (isEmptyObj(this.state.loginInfo)) {
                    this.props.requestJoinMixedClassLive({
                        liveSeq: this.props.mixedClassInfo.liveSeq,
                        liveName: this.props.mixedClassInfo.liveName,
                        userSeq: this.props.userSeq,
                        userNickname: this.props.userNickname,
                        mixedClassSeq: this.props.mixedClassInfo.mixedClassSeq
                    });
                } else {
                    this.props.requestJoinMixedClassLive({
                        liveSeq: this.props.mixedClassInfo.liveSeq,
                        liveName: this.props.mixedClassInfo.liveName,
                        userSeq: this.props.userSeq,
                        userNickname: this.state.loginInfo.userNickname,
                        mixedClassSeq: this.props.mixedClassInfo.mixedClassSeq
                    });
                }

                break;

            case "LOGIN_FOR_MIXED":
                // 20260819 로그인 화면에서 선택한 보정값을 저장 설정보다 우선하여 라이브 이동 주소에 반영한다.
                if (typeof loginInfo.rotateCapture === "boolean") this.rotateCapture = loginInfo.rotateCapture;
                // 20260820 Mixed 클래스 재로그인 전에 이전 로그인 오류 메시지를 초기화한다.
                this.props.setLoginMessage("", "none");

                this.props.saveTempMixedUserInfo({ loginInfo });
                sendRequestMixedClassLogin(loginInfo.userSeq);
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <>
                <MixedClassLoginWindow 
                    live_info={this.props.mixedClassInfo}
                    list_member={this.props.mixedClassInfo.list_member}
                    isLoginDataResolved={this.props.isRcvMixedClassLoginResponse}
                    loginEntryFailure={this.props.loginEntryFailure}
                    isInvalidRoute={this.props.isInvalidRoute}
                    alertKind={this.props.alertKind}
                    loginMessage={this.props.loginMessage}
                    handleSelectedFunc={this.handleSelectedFunc}
                />
            </>
        );
    }
}

export default connect(
    ({ live, user, hiclasstv }) => ({
        isLoginYn                   : user.isLoginYn,

        userSeq                     : user.userSeq,
        userNickname                : user.userNickname,
        mySubDomainSeq              : user.mySubDomainSeq,

        userKind                    : user.userKind,

        mixedClassInfo              : live.mixedClassInfo,
        isRcvMixedClassLoginInfo    : live.isRcvMixedClassLoginInfo,
        // 20260820 Mixed 클래스 RabbitMQ 로그인 응답 수신 여부를 전달한다.
        isRcvMixedClassLoginResponse: live.isRcvMixedClassLoginResponse,
        loginEntryFailure           : live.loginEntryFailure,

        isGotoWebLive               : live.isGotoWebLive,

        performLiveSeq              : live.performLiveInfo.liveSeq,

        alertKind                   : user.alertKind,
        loginMessage                : user.loginMessage,

        isRbmqServerConnected       : user.isRbmqServerConnected,

        isInvalidRoute              : live.isInvalidRoute
    }),
    {
        toggleIsNeedGoToHome,
        requestJoinMixedClassLive,

        setLoginMessage,
        saveTempMixedUserInfo,
        requestMixedClassLoginList,
        reqeustMixedClassLogout
    }
)(MixedLoginContainer);
